import { formatTime, type UserAdminView } from '@kominiarz/shared';
import { Badge } from '../../components/Badge';

/** Account state badges; text, not colour alone, carries the meaning. */
export function UserStatus({ user }: { user: UserAdminView }) {
  return (
    <>
      {!user.isActive && <Badge tone="neutral">Konto wyłączone</Badge>}
      {user.isActive && user.lockedUntil && <Badge tone="danger">Zablokowane do {formatTime(user.lockedUntil)}</Badge>}
      {user.isActive && user.mustChangePassword && <Badge tone="info">Musi ustawić hasło</Badge>}
    </>
  );
}
